import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { environment } from 'src/environments/environment';
import { SettingsService } from 'src/app/core/spectrum/_services/settings.service';

@Component({
  selector: 'app-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrls: ['./release-notes.component.css']
})
export class ReleaseNoteComponent implements OnInit {

  apiEndPoint: string;
  key = environment.API_KEY as unknown as {value: ''};

  fileFormat = "spectrum";
  
  constructor(
    private settingsService: SettingsService,
    public dialogRef: MatDialogRef<ReleaseNoteComponent>
  ) {
    this.apiEndPoint = this.settingsService.settings.SPECTRUM_API;
   }

  ngOnInit() {
  }
  


  closeModal() {
    this.dialogRef.close(null);
  }
}
